// extracted by mini-css-extract-plugin
module.exports = {"Contacts":"styles_Contacts__19Kxt","Contact":"styles_Contact__3ejX3","contactInfo":"styles_contactInfo__27EQD"};